<style>
</style>

<template>
<v-row dense>
  <v-col cols="12">
    <div class="font-weight-bold">{{ $t('Platební metody') }}</div>
  </v-col>
  <v-col cols="12">
    <select-instruments @paymentInstrument="instrumentChanged"></select-instruments>
    <div class="grey--text caption text-center">{{ $t('Všechny transkace jsou zabezpečené a šifrované') }}</div>
  </v-col>
</v-row>
</template>

<script>
import SelectInstruments from '@/components/select-instruments.vue'
import BasketMixin from '../mixins/basket-mixin.js'
export default {
  mixins: [BasketMixin],
  components: {
    'select-instruments': SelectInstruments
  },
  methods: {
    instrumentChanged(value) {
      this.$emit('paymentInstrument', value.paymentInstrument)
    }
  }
}
</script>
